import style from "../../../../assets/stylesheets/sass/UserManagement.module.scss";
import refresh_icon_white from "../../../../assets/icons/refresh_icon_white.svg";
import warning_icon_white from "../../../../assets/icons/warning_icon_white.svg";

import { ReactSession }  from 'react-client-session';
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from 'axios'
import toast, {Toaster} from 'react-hot-toast'

const Checkbox = ({checked, onCheck}) => {
    return (
        <label className={style.checkbox} id={checked.toString()}>
            <input type="checkbox" checked={checked} onChange={(e)=>{onCheck(e.currentTarget.checked)}}/>
            <span className={style.checkmark}></span>
        </label>
    )
}

export default function CompleteTable({dostypes, doctypes}){
    const filetypes = useSelector(state => state.filetypes)
    const doctypesTranslations = useSelector(state => state.doctypesTranslations)
    const filetypesTranslations = useSelector(state => state.filetypesTranslations)

    const [object, setobject] = useState();

    useEffect(()=>{
        getData()
    }, [])

    const getData = async () => {
        let userdata = JSON.parse(window.sessionStorage.getItem("user_data"));
        let a_f = await fetch(`${process.env.REACT_APP_SERVER_LINK}adminSettingsGet?token=${userdata.token}`)
        a_f = await a_f.json();
        if(a_f.errorcode === 0){
            let adminSettings = a_f.object.json;
            if(adminSettings.complete_table){
                console.log(adminSettings.complete_table)
                

                const newObject = await checkNewDoctypes(adminSettings.complete_table)
                if(newObject) {
                    setobject(newObject)
                    console.log(newObject)
                }
                setobject(adminSettings.complete_table)
            }
            else {
                //No settings for the table found
            }
        }
        else {
            //Failed to get admin settings
        }
    }

    const checkNewDoctypes = async (currentTable) => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}documentTypes?token=${process.env.REACT_APP_FITDOC_ADMTOK}`)
            if(data.errorcode === 0 && Array.isArray(data.object)){
                let missingDoctypes =  [];
                let currentDoctypes = Object.keys(currentTable[Object.keys(currentTable)[0]])
                data.object.forEach((doctype) => { if(!currentDoctypes.includes(doctype.doctype)){missingDoctypes.push(doctype.doctype)} })
                if(missingDoctypes.length > 0){
                    Object.keys(currentTable).forEach((key, ind) => {
                        missingDoctypes.forEach((missingDoc, i) => {
                            currentTable[key][missingDoc] = false;
                        })
                    })
                    return currentTable;
                }
                return null
            }
            else {
                console.log(data);
                console.error('Error')
                return null;
            }
            
        } catch (error) {
            console.log(error)
        }
    }

    const resetTable = async () => {
        var resp = window.prompt("Are you sure you want to reset all rights? (type: yes)");
        if(resp === "yes"){
            let obj = {}
            if(Array.isArray(dostypes)){
                dostypes.forEach(filetype => {
                    obj[filetype.dossiertypeid] = {}
                });

                if(Array.isArray(doctypes)){
                    Object.keys(obj).forEach((key, index)=>{
                        doctypes.forEach(doctype => {
                            obj[key][doctype.doctype] = false
                        });
                    })
                }

                setobject(obj);

                let userdata = JSON.parse(window.sessionStorage.getItem("user_data"));
                let a_f = await fetch(`${process.env.REACT_APP_SERVER_LINK}adminSettingsGet?token=${userdata.token}`)
                a_f = await a_f.json();
                if(a_f.errorcode === 0){
                    let adminSettings = a_f.object;
                    adminSettings.json.complete_table = obj;

                    //Update admin settings
                    let update = await fetch(`${process.env.REACT_APP_SERVER_LINK}adminSettingsUpdate?token=${userdata.token}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(adminSettings)
                    })
                    update = await update.json();
                }
                else {
                    //Failed to get admin settings
                }
            }
        }
    }

    const filetypeIdToName = (id) => {
        let ft = filetypes.find(filetype => parseFloat(filetype.dossiertypeid) === parseFloat(id))
        return ft.name
    }

    const changeCheckbox = async (filetype, doctype, value) => {
        let o = {...object}
        o[filetype][doctype] = value;
        setobject(o);

        let userdata = JSON.parse(window.sessionStorage.getItem("user_data"));
        let a_f = await fetch(`${process.env.REACT_APP_SERVER_LINK}adminSettingsGet?token=${userdata.token}`)
        a_f = await a_f.json();
        if(a_f.errorcode === 0){
            let adminSettings = a_f.object;
            adminSettings.json.complete_table = o;

            //Update admin settings
            try {
                toast.loading('Wijzigingen opslaan...', {id:'saving', position:'bottom-right'})
                let update = await fetch(`${process.env.REACT_APP_SERVER_LINK}adminSettingsUpdate?token=${userdata.token}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(adminSettings)
                })
                update = await update.json();
                if(update.errorcode === 0){ toast.success('Wijzigingen opgeslagen!', {id:'saving'}) }
                else { toast.error('Wijzigingen opslaan mislukt', {id:'saving'}) }
            } catch (error) {
                console.log(error);
                toast.error('Wijzigingen opslaan mislukt', {id:'saving'})
            }
            
        }
    }

    const reloadFileStatus = async () => {
        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}updateFileStatus`);
        let r = await f.json();
        console.log(r);
    }

    return (
        <>
        <Toaster />
        <div className={`${style.completepage} ${style.sub_content}`}>
            <div className={style.role_top}>
                <p className={style.sub_content_title}>Volledigheid</p>
                <div className={style.header_buttons_row}>
                    <button className={style.reloadsettings_button} onClick={()=>{reloadFileStatus()}}><p>Herlaad dossier statussen</p><img src={refresh_icon_white} alt="settings icon"/></button>
                    <button className={style.reset_button} onClick={()=>{resetTable()}}><p>Tabel resetten</p><img src={warning_icon_white} alt="delete icon"/></button></div>
                </div>   
            <div>

            {object ? 
            <div className={style.tbl}>
                <div className={style.header}>
                    <i className={style.header_item}></i>
                    {object && Object.keys(object[(Object.keys(object)[0])]).map((doctype, index)=>{
                        return (
                            <p className={style.header_item} key={index}>{doctypesTranslations[doctype] ? doctypesTranslations[doctype][ReactSession.get("language")] : doctype}</p>
                        )
                    })}
                </div>
                
                <div className={style.body}>
                    {object && Object.keys(object).map((filetype, index)=>{
                        return (
                            <div className={style.body_row} key={index}>
                                <p className={`${style.body_row_first} ${style.body_row_item}`}>{filetypesTranslations[filetypeIdToName(filetype)] ? filetypesTranslations[filetypeIdToName(filetype)][ReactSession.get("language")] : filetype}</p>
                                {Object.keys(object[filetype]).map((doctype, ind)=>{
                                    return (
                                        <p className={style.body_row_item} key={ind}>{object[filetype][doctype] ? <Checkbox onCheck={(value)=>{changeCheckbox(filetype, doctype, value)}} checked={true}/> : <Checkbox onCheck={(value)=>{changeCheckbox(filetype, doctype, value)}} checked={false}/>}</p>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            </div>
            :
            <p>Even geduld...</p>
            }
            </div>
        </div>
        </>
    )
}